import React from 'react'

import { FONT_FAMILY, PADDING } from '../constants'

export default function Marker({ point, scaleX, scaleY }) {
  if (!point) {
    // Do not render if there is no value
    return null
  }

  const [left, right] = scaleX.range()

  const x = scaleX(point.x)
  const y = scaleY(point.y)
  const r = Math.min(12, Math.abs(right - left) * 0.02)

  return (
    <g fontFamily={FONT_FAMILY} fill="#444" className="trend-line-marker">
      <circle cx={x} cy={y} r={r} />

      <text
        x={x}
        y={y - (r + PADDING)}
        textAnchor="middle"
        dominantBaseline="central"
      >
        {point.title}
      </text>
    </g>
  )
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/marker.js